export const toggleColumnState = ({ id, section }) => (state, actions) => {
  const columns = [...state[section].columns];

  const column = columns.find(column => column.id === id);

  column.selected = !column.selected;

  Promise.resolve({ section }).then(actions.saveColumns);

  return {
    ...state,
    [section]: {
      ...state[section],
      columns,
    },
  };
};
